import DayTwoOperation from '@shell/models/day-two-operation';

export default class EncryptionKeyRotation extends DayTwoOperation {}
